module.exports = __webpack_public_path__ + "static/media/Slideshow-Carousel.071845d0.md";